import React, { useState, useEffect } from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import ThankYou from "../collect-payment/ThankYou";
import AlertErrorMessage from "../../components/AlertErrorMessage";

enum SubmittedStates {
  Loading,
  Success,
  Failure,
}

type BindRequestProps = {
  bindRequest: {
    effectiveDate: string;
    files: string;
    comments: string;
    plan: string;
    policyQuoteId: string;
    autoPay: string;
    clientId: string;
  };
};

export function SurplusLinesSubmitBindRequest({
  bindRequest,
}: BindRequestProps) {
  const [submitted, setSubmitted] = useState(SubmittedStates.Loading);

  useEffect(() => {
    axios({
      url: BACKEND_CONFIG.apiUrl + "panels/submit-bind-with-payment-request",
      method: "post",
      data: {
        PaymentWorkflow: false,
        EffectiveDate: bindRequest.effectiveDate,
        PaymentPlan: bindRequest.plan,
        PaymentMethod: "Third party", // Indicates this Surplus Lines bind request payment is being handled by a third party - not our usual payment handling.
        QuoteId: bindRequest.policyQuoteId,
        Files: bindRequest.files,
        ClientId: bindRequest.clientId,
        // The payload items below are needed downstream during bind-request process, and will also serve to inform users that click the subsequently created "Order" primary_order AR (created during BindRequest process linked below)
        // That this order is for SurplusLines and doesn't have valid payment info.
        // References
        // https://staging-ams.internal.apps.mycommercialexchange.com/#/client/8860ef77-bb9c-4f08-8549-4cd4f532b991/orders
        // https://bitbucket.insureondev.com/projects/ATOM/repos/allstateprocess/browse/Ion.AllstateAgencyQuoteBindRequestProcess.Server/Process.cs#113
        // https://bitbucket.insureondev.com/projects/ATOM/repos/agencyportal/browse/Ion.AgencyPortal/Services/Allstate/AllstateBindRequest.cs
        FirstName: "SurplusLines",
        LastName: "SurplusLines",
        Address: {
          Address1: "SurplusLines",
          Zip: "00000",
          City: "SurplusLines",
          State: "SurplusLines",
        },
        Token: "0000",
        AutoPay: false,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        debugger;
        setSubmitted(SubmittedStates.Success);
      })
      .catch((error) => {
        setSubmitted(SubmittedStates.Failure);
      });
  }, []);

  switch (submitted) {
    case SubmittedStates.Loading:
      return null;
    case SubmittedStates.Success:
      return <ThankYou />;
    case SubmittedStates.Failure:
      return <ErrorMessage />;
  }
}

function ErrorMessage() {
  return (
    <div className="white-content-box">
      <AlertErrorMessage message="Sorry, there was a problem submitting your bind request. Please try again or contact your administrator." />
    </div>
  );
}
